var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import isEmpty from 'lodash.isempty';
import { useNavigate } from 'react-router-dom';
import { FactoryContent } from '../../../factory';
import withDesign from '../../../hocs/withDesign';
import useWatch from '../../../hooks/useWatch';
import { interpolate } from '../../../utils/strings';
import { TranslatedText } from '../TranslatedText';
import { StyledAnchor, StyledLink as RouterStyledLink } from './styled';
function isExternalLink(link) {
    return !!(link === null || link === void 0 ? void 0 : link.match(/^(https:\/\/|http:\/\/)/));
}
export var LinkContent = function (_a) {
    var config = _a.config, design = _a.design, i18nValues = _a.i18nValues, children = _a.children;
    if (children)
        return children;
    if (isEmpty(config.content)) {
        return _jsx(TranslatedText, { i18n: config.i18n, design: design, values: i18nValues });
    }
    return _jsx(FactoryContent, { config: config });
};
export var LinkComponent = function (_a) {
    var design = _a.design, values = _a.values, i18nValues = _a.i18nValues, children = _a.children, schema = _a.schema, translatedText = _a.components.translatedText, to = _a.to, config = __rest(_a, ["design", "values", "i18nValues", "children", "schema", "components", "to"]);
    var navigate = useNavigate();
    var watchedValues = useWatch(config.watch);
    var toWithValues = interpolate(to, watchedValues);
    if (isExternalLink(toWithValues)) {
        return (_jsx(StyledAnchor, __assign({ schema: schema }, config, { href: toWithValues }, { children: _jsx(LinkContent, { design: translatedText, config: config, i18nValues: i18nValues, children: children }) })));
    }
    var isBackLink = parseInt(toWithValues) === -1;
    var handleBackNavigation = isBackLink ? function () { return navigate(-1); } : undefined;
    return (_jsx(RouterStyledLink, __assign({ schema: schema, onClick: handleBackNavigation }, config, { to: isBackLink ? '#' : toWithValues }, { children: _jsx(LinkContent, { design: translatedText, config: config, i18nValues: i18nValues, children: children }) })));
};
export var Link = withDesign(LinkComponent);
Link.displayName = 'Link';
export * from './Link.types';
